export const getAppModuleId = () : number => {
    const appModuleLocalStorage = localStorage.getItem("appModule");
    
    return appModuleLocalStorage ?  Number(appModuleLocalStorage) : 4;
}